import { render, staticRenderFns } from "./TeamSection.vue?vue&type=template&id=29077dd3&scoped=true&"
import script from "./TeamSection.vue?vue&type=script&lang=js&"
export * from "./TeamSection.vue?vue&type=script&lang=js&"
import style0 from "./TeamSection.vue?vue&type=style&index=0&id=29077dd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29077dd3",
  null
  
)

export default component.exports